import axios from "axios";
import { ADVISER_IDENTIFIER, ANALYTICS_API_URL, ANSWERS_API_URL, CONTACT_API_URL, PREDICT_API_URL, SENDGRID_RECOMMENTATIONS_URL, SENDGRID_SERVICE_URL, SERVICES_API_URL } from "../../env";

const config = {
  headers: {
    "Content-Type": "application/json"
  }
};

export const sendNotificationEmail = (body: any) => {
  return axios.post(`${SENDGRID_SERVICE_URL}`, body, config)
}

export const uploadCommentRequest = (body: any) => {
  return axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/comments/`, body, config)
}

export const uploadEventRequest = (data: any, adviserCode: string) => {
  return axios.post(`${ANALYTICS_API_URL}/${btoa(adviserCode || "")}/analytics/new/`, data, config)
}

export const uploadLocationRequest = (body: any) => {
  return axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/locations/`, body, config)
}

export const uploadIdentificationRequest = (body: any) => {
  return axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/identifications/`, body, config)
}

export const uploadAnswersRequest = (body: any) => {
  return axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/`, body, config)
}

export const uploadEmailToAnswersRequest = (body: any) => {
  return axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/emails/`, body)
}

export const uploadContactDataRequest = (data: any) => {
  return axios.post(`${CONTACT_API_URL}/${ADVISER_IDENTIFIER}/contacts/`, data, config)
}

export const getResultPredictedRequest = (body: any) => {
  return axios.post(`${PREDICT_API_URL}/api/v1/predict/`, body, config)
}

export const getRecommendedServicesRequest = (body: any) => {
  return axios.post(`${SERVICES_API_URL}/${ADVISER_IDENTIFIER}/services/recommended/`, body, config)
}

export const sendRecommendationsEmail = (body: any) => {
  return axios.post(`${SENDGRID_RECOMMENTATIONS_URL}`, body, config)
}

export const sendDataToCrm = (body: any) => {
  const formData = new FormData();

  Object.keys(body).forEach((key) => {
    formData.append(key, body[key]);
  });

  const configFormData = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };

  return axios.post(`https://app.crece.pro/api.php/capturador/formulario/1788b9b7/`, formData, configFormData)
}